
import "./privacypolicy.css";
import React from "react";

const PrivacyPolicy = () => (
  <div className="privacy-policy-container">
    <h1>Privacy Policy</h1>
    <p>
      Cysigil Network Pvt Ltd. operates the <a href="https://www.cysigil.com/">https://www.cysigil.com/</a> website (the “Service”).
      This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. Our Privacy Policy for Cysigil Network Pvt Ltd. is managed through Free Privacy Policy.
    </p>
    <p>
      We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from <a href="https://www.cysigil.com/">https://www.cysigil.com/</a>
    </p>
    <h2>Information Collection and Use</h2>
    <p>
      We collect several different types of information for various purposes to provide and improve our Service to you.
    </p>
    <h3>Types of Data Collected</h3>
    <h4>Personal Data</h4>
    <p>
      While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally, identifiable information may include, but is not limited to:
    </p>
    <ul>
      <li>Email address</li>
      <li>First name and last name</li>
      <li>Phone number</li>
    </ul>
    <h4>Cookies and Usage Data</h4>
    <h4>Usage Data</h4>
    <p>
      We may also collect information on how the Service is accessed and used (“Usage Data”). This Usage Data may include information such as your computer’s Internet Protocol address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
    </p>
    <h4>Tracking & Cookies Data</h4>
    <p>
      We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.
      Cookies are files with a small amount of data that may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.
      You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
    </p>
    <p>Examples of Cookies we use:</p>
    <ul>
      <li>Session Cookies: We use Session Cookies to operate our Service.</li>
      <li>Preference Cookies: We use Preference Cookies to remember your preferences and various settings.</li>
      <li>Security Cookies: We use Security Cookies for security purposes.</li>
    </ul>
    <h2>Use of Data</h2>
    <ul>
      <li>To provide and maintain the Service</li>
      <li>To notify you about changes to our Service</li>
      <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
      <li>To provide customer care and support</li>
      <li>To provide analysis or valuable information so that we can improve the Service</li>
      <li>To monitor the usage of the Service</li>
      <li>To detect, prevent and address technical issues</li>
    </ul>
    <h2>Transfer of Data</h2>
    <p>
      Your information, including Personal Data, is not transferred outside of India.
      If you are located outside India and choose to provide information to us, please note that we transfer and process the data, including Personal Data, to India with data protection guidelines.
      Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
      Cysigil Network Pvt Ltd. will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.
    </p>
    <h2>Disclosure of Data</h2>
    <h3>Legal Requirements</h3>
    <p>
      Cysigil Network Pvt Ltd. may disclose your Personal Data in the good faith belief that such action is necessary to:
    </p>
    <ul>
      <li>To comply with a legal obligation</li>
      <li>To protect and defend the rights or property of Cysigil Network Pvt Ltd.</li>
      <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
      <li>To protect the personal safety of users of the Service or the public</li>
      <li>To protect against legal liability</li>
    </ul>
    <h2>Security of Data</h2>
    <p>
      The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
    </p>
    <h2>Service Providers</h2>
    <p>
      We do not share your Personal Data with third-party companies or individuals, except as necessary to provide our Service or as required by law. Your Personal Data remains strictly within our control and is not disclosed or used by any third parties for other purposes.
    </p>
    <h2>Google Analytics</h2>
    <p>
      Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network.
      You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing information with Google Analytics about visits activity.
      For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en</a>
    </p>
    <h2>Statcounter</h2>
    <p>
      Statcounter is a web traffic analysis tool. You can read the Privacy Policy for Statcounter here: <a href="https://statcounter.com/about/legal/">https://statcounter.com/about/legal/</a>
    </p>
    <h2>Changes To This Privacy Policy</h2>
    <p>
      We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
      You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
      Any personal data collected will be used by Cysigil Network Pvt Ltd. to contact you via phone, SMS, or email for marketing and to deliver certain updates for services or information you have requested.
    </p>
    <h2>Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us:<br />
      By email: <a href="mailto:info@cysigil.com">info@cysigil.com</a>
    </p>
  </div>
);

export default PrivacyPolicy;
